import { useCallback, useEffect, useState } from 'react';

import { listInAppAvailabilities } from 'lib/models/order';

function useInAppAvailabilities(productId?: string) {
	const [loading, setLoading] = useState<boolean>(false);
	const [availabilities, setAvailabilities] = useState<InAppAvailability[]>([]);
	const [availability, setAvailability] = useState<InAppAvailability | null>(null);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await listInAppAvailabilities();
		setAvailabilities(response);
		setLoading(false);
	}, []);

	useEffect(() => {
		if (productId && availabilities.length) {
			const found = availabilities.find((availability) => {
				return `${availability.product}` === `${productId}`;
			});
			setAvailability(found || null);
		}
	}, [productId, availabilities]);

	useEffect(() => {
		refetch();
	}, [refetch]);
	return { loading, availabilities, availability, refetch, setLoading };
}

export default useInAppAvailabilities;
